import { render, staticRenderFns } from "./BurbleAlert.vue?vue&type=template&id=58a40e7e&scoped=true"
import script from "./BurbleAlert.vue?vue&type=script&lang=js"
export * from "./BurbleAlert.vue?vue&type=script&lang=js"
import style0 from "./BurbleAlert.vue?vue&type=style&index=0&id=58a40e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a40e7e",
  null
  
)

export default component.exports